/**
 * 改造下：保存二进制数据，在需要渲染时，才转换为json数据；
 */

export function LinkedList() {
  var head = new ListNode('HEAD');
  var tail = null;
  var length = 0;
  var count = 0;
  var data_list = []//原始数据保存的list
  let data_index = 0;//作为播放的标记；

  /**
   * 新收到一帧数据，放在队尾；
   * @param {*} data 
   */
  this.offer = function (data) {
    data_list.push(data)
  };

  /**
   * 获取当前要播放的数据；根据data_index来标记
   * @returns 
   */
  this.poll = function () {
    if (data_list.length > data_index) {
      let data = ListNode(data_list[data_index])
      data_index++
      return data;
    } else {
      return null;
    }
  };

  // return the node at the head of the list
  this.take = function () {
    if (data_list.length > data_index) {
      let data = ListNode(data_list[data_index])
      return data;
    } else {
      return null;
    }
  };


  /**
   * 数据长度
   * @returns 
   */
  this.size = function () {
    return data_list.length;
  };

  this.clear = function () {
    console.log('clear');
    data_list = [];
    data_index = 0;
  };



  // add node to the head of the list
  this.unshift = function (data) {
    const node = new ListNode(data);
    node.next = head.next;
    head.next = node;
    if (tail === null) {
      tail = node;
    }
    length = length + 1;
  };

  this.sizeJson = function () {
    let blob = new Blob([JSON.stringify(tail)]);
    let size = (blob.size / (1024 * 1024)).toFixed(2) + "MB";
    return size;
  }


}

function ListNode(data) {
  this.data = data;
  this.next = null;
}
